import { getFormFieldHelperTextClassName } from "@config/theme/formControls";

export interface FormFieldHelperTextProps {
	children?: string;
	error?: boolean;
	className?: string;
}

const FormFieldHelperText = ({ children, error, className }: FormFieldHelperTextProps) => {
	if (!children) return null;

	return (
		<p className={className ?? getFormFieldHelperTextClassName(error)} role={error ? "alert" : undefined}>
			{children}
		</p>
	);
};

export default FormFieldHelperText;
